const style = {
  display: "flex",
  flex: "1 1 0",
  height: 400
};

export function SelectorsContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
